import type { IPwaNotificationStore } from './types'

let pwaState: IPwaNotificationStore = {
  isShown: false,
  isDismissed: false,
}

let listeners: (() => void)[] = []

export const PwaPromptStore = {
  setShown(shown: IPwaNotificationStore['isShown']) {
    pwaState = {
      ...pwaState,
      isShown: shown,
    }

    emitChange()
  },
  setClosed() {
    pwaState = { ...pwaState, isDismissed: true }
    emitChange()
  },

  subscribe(listener: () => void) {
    listeners = [...listeners, listener]

    return () => {
      listeners = listeners.filter(l => l !== listener)
    }
  },

  getSnapshot() {
    return pwaState
  },
}

function emitChange() {
  for (const listener of listeners) {
    listener()
  }
}
